import * as React from 'react';

export default function ExtraResources(props) {
  const {
    label = '',
    items = [],
  } = props;

  if (items.length === 0) return null;

  return (
    <div className='sidebar-block'>
      {label && <p className='h--smallest mb-3'>{label}</p>}
      <ul className='nv-list quick-links'>
        {items.map((item, idx) => (
          <li key={idx}>
            <a href={item.url}>{item.text}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
